import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SdvorButtonComponent, SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sd-no-orders-block',
  styleUrls: ['./no-orders-block.scss'],
  templateUrl: './no-orders-block.html',
  imports: [SdvorIconComponent, SdvorButtonComponent, RouterLink],
})
export class NoOrdersBlockComponent {
  iconTypes = IconTypes;
}
